module.exports = __webpack_public_path__ + "static/media/earth.654b57a6.png";